import { useEffect, useState } from 'react';

export function useTabsNavIsNarrow() {
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const el = document.getElementById('observable');

    if (!el) return;

    const checkWidth = () => setIsNarrow(el.offsetWidth <= 670);
    checkWidth();

    const ro = new ResizeObserver(checkWidth);
    ro.observe(el);

    window.addEventListener('resize', checkWidth);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', checkWidth);
    };
  }, []);

  return isNarrow;
}
